import styled from 'styled-components';

export const Container = styled.section`
  display: flex;
  font-family: 'Noto Sans TC', sans-serif;
  font-size: 33px;
  font-weight: 600;
`;
Container.displayName = 'Container';

export const PlayerDivider = styled.div`
  padding: 0 8px;
`;
PlayerDivider.displayName = 'PlayerDivider';

export const PlayerOne = styled.div`
  color: ${({ isServing }) => (isServing ? '#daff01' : '#97cbe7')};
  margin-left: 40px;
  &:before {
    content: ${({ isServing }) => (isServing ? `"●"` : '')};
    font-size: 15px;
    position: absolute;
    top: 18px;
    left: 15px;
  }
`;
PlayerOne.displayName = 'PlayerOne';

export const PlayerTwo = styled.div`
  color: ${({ isServing }) => (isServing ? '#daff01' : '#97cbe7')};
  margin-right: 40px;
  &:after {
    content: ${({ isServing }) => (isServing ? `"●"` : '')};
    font-size: 15px;
    position: absolute;
    top: 18px;
    right: 15px;
  }
`;
PlayerTwo.displayName = 'PlayerTwo';

export const Points = styled.div`
  align-items: center;
  background-color: #fff;
  border: 3px solid #97cbe7;
  color: #283b76;
  display: flex;
  height: 60px;
  justify-content: center;
  min-width: 60px;
  position: relative;
  text-align: center;

  &:first-child {
    border-bottom: 0px;
  }
  &:nth-child(2) {
    border-top: 0px;
    padding-top: 3px;

    &:before {
      background-color: #283b76;
      content: '';
      height: 3px;
      position: absolute;
      right: 9px;
      top: 0;
      width: 30px;
    }
  }

  ${({ isGoldPoint }) =>
    isGoldPoint &&
    `
      background: rgb(250,239,179);
      background: linear-gradient(90deg, rgba(250,239,179,1) 0%, rgba(224,188,99,1) 100%);
  `}
`;
Points.displayName = 'Points';

export const PointsContainer = styled.div`
  display: flex;
  flex-direction: column;
`;
PointsContainer.displayName = 'PointsContainer';

export const Set = styled.div`
  align-items: center;
  background-color: #283b76;
  border: 3px solid #97cbe7;
  border-left: 0px;
  border-right: 0px;
  color: #97cbe7;
  display: flex;
  height: 60px;
  justify-content: center;
  min-width: 56px;
  text-align: center;

  &:first-child {
    border-bottom: 0px;
  }
`;
Set.displayName = 'Set';

export const SetContainer = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;

  ${({ last }) =>
    !last &&
    `
  &:not(:last-child):before {
    background-color: #97cbe7;
    content: '';
    height: 30px;
    position: absolute;
    right: 0;
    top: 47px;
    width: 3px;
  }
  `}
`;
SetContainer.displayName = 'SetContainer';

export const TeamNameContainer = styled.div`
  display: flex;
  flex-direction: column;
`;
TeamNameContainer.displayName = 'TeamNameContainer';

export const TeamName = styled.div`
  align-items: center;
  background-color: #283b76;
  border: 3px solid #97cbe7;
  color: #97cbe7;
  display: flex;
  height: 60px;
  justify-content: center;
  min-width: 170px;
  position: relative;
  text-align: center;

  &:first-child {
    border-bottom: 0px;
  }
`;
TeamName.displayName = 'TeamName';

export const Timer = styled.div`
  align-items: center;
  background-color: #333;
  color: #fff;
  display: flex;
  justify-content: center;
  min-width: 130px;
  padding: 0 16px;
  text-align: center;
`;
Timer.displayName = 'Timer';
